<template>
    <Transition name="fade-up" mode="out-in">
        <slot></slot>
    </Transition>
</template>

<style lang="scss">

    .fade-up-enter-active,
    .fade-up-leave-active 
    {
        transition: all 120ms ease;
        opacity: 1;
        transform: translateY( 0 );
    }

    .fade-up-enter-from,
    .fade-up-leave-to 
    {
        opacity: 0;
        transform: translateY( 8px );
    }

</style>